import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { PUBLIC_UTILS } from '../public-utils';
const initialState = { modals: {}, slideOuts: {}, toasts: {}, persistentModals: {} };
export const OverlaysApiContext = React.createContext(null);
let overlaysApiInstance;
export function WuiOverlayProvider({ children }) {
    // Overlays API will only be constructed once
    const overlaysApiPrivate = React.useMemo(() => new PUBLIC_UTILS.WuiOverlaysAPI(), []);
    const overlaysApiPublic = React.useMemo(() => overlaysApiPrivate.getPublicApi(), [overlaysApiPrivate]);
    // Hoist public api out of scope
    overlaysApiInstance = overlaysApiPublic;
    const [_state, _setState] = React.useState(initialState);
    // Create simple state store, we are using useRef instead of setState to
    // ensure each set call will immediately update get and set functions even
    // within the same render cycle. Otherwise multiple consecutive set calls
    // would be overridden with the last set call in that render cycle.
    const stateRef = React.useRef({
        get: () => initialState,
        set: (stateFn) => {
            const oldState = stateRef.current.get();
            const nextState = stateFn(oldState);
            stateRef.current.get = () => nextState;
            // Ensure the overlays api knows about our new state
            overlaysApiPrivate.updateStore(stateRef.current.get, stateRef.current.set);
            // Trigger render
            _setState(nextState);
        },
    });
    // As soon as getState or setState changes
    React.useEffect(() => {
        // Ensure the overlays api knows about our new state
        overlaysApiPrivate.updateStore(stateRef.current.get, stateRef.current.set);
    }, [overlaysApiPrivate]);
    return (_jsx(OverlaysApiContext.Provider, { value: { api: overlaysApiPublic, state: _state }, children: children }));
}
export function getWuiOverlaysApi() {
    if (!overlaysApiInstance) {
        throw new Error('<WuiOverlayProvider /> not initialized!');
    }
    return overlaysApiInstance;
}
